"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_apollo_1 = require("react-apollo");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var modal_1 = require("../../components/common/modal");
var form_element_hook_1 = require("../../components/form/form-element-hook");
var ConnectDivisionToOrganization = require("../../core/gql/mutations/connect-division-to-organization");
var SetFeedbackMessage = require("../../core/gql/mutations/set-feedback-message");
var react_hook_form_1 = require("react-hook-form");
var ConnectElement = form_element_hook_1.default;
var OrganizationConnect = function (_a) {
    var shouldShowModal = _a.shouldShowModal, setShouldShowModal = _a.setShouldShowModal, organizationId = _a.organizationId;
    var _b = react_apollo_1.useMutation(ConnectDivisionToOrganization.MUTATION), connectOrganization = _b[0], connectOrganizationResponse = _b[1];
    var setFeedbackMessage = react_apollo_1.useMutation(SetFeedbackMessage.MUTATION)[0];
    var submit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, graphQLErrors, errors;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, connectOrganization({
                            variables: { divisionId: values.divisionId, organizationId: organizationId },
                        })];
                case 1:
                    _b.sent();
                    setFeedbackMessage({
                        variables: {
                            message: "Organization connected.",
                            autoclose: true,
                            isError: false,
                        },
                    });
                    setShouldShowModal(false);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    graphQLErrors = _a.graphQLErrors;
                    if (graphQLErrors) {
                        errors = graphQLErrors.map(function (_a) {
                            var message = _a.message;
                            return message;
                        });
                        setFeedbackMessage({
                            variables: {
                                message: errors.join(". "),
                                autoclose: true,
                                isError: true,
                            },
                        });
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var isSubmitting = connectOrganizationResponse.loading;
    var organizationConnectForm = react_hook_form_1.useForm();
    var register = organizationConnectForm.register, handleSubmit = organizationConnectForm.handleSubmit;
    return (React.createElement(modal_1.default, { isOpen: shouldShowModal, onClose: function () { return setShouldShowModal(false); } },
        React.createElement("div", { id: "organization-connect-editor-content" },
            React.createElement("form", { onSubmit: handleSubmit(submit) },
                React.createElement(teamsnap_ui_1.Panel, { mods: "Panel--form" },
                    React.createElement(teamsnap_ui_1.PanelHeader, { title: "Division Details" }),
                    React.createElement(teamsnap_ui_1.PanelBody, null,
                        React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "Panel-cell--header u-size3of12 u-flex u-flexAlignItemsCenter" },
                                React.createElement("h4", null, "Division ID")),
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size9of12" },
                                React.createElement(ConnectElement, { useHookResponse: organizationConnectForm, inputRef: register({
                                        required: "You must enter the division's id.",
                                    }), label: "Division Id", labelHidden: true, type: "text", field: "divisionId", placeholder: "Division Id" }))),
                        React.createElement(teamsnap_ui_1.PanelFooter, { mods: "u-textLeft" },
                            React.createElement("div", { className: "button-list" },
                                React.createElement(teamsnap_ui_1.Button, { mods: "Button--negative", icon: "dismiss", onClick: function () { return setShouldShowModal(false); } }, "Cancel"),
                                React.createElement(teamsnap_ui_1.Button, { isDisabled: isSubmitting, color: "primary", type: "submit", icon: isSubmitting ? null : "check" },
                                    isSubmitting && React.createElement(teamsnap_ui_1.Loader, { type: "spin", style: { width: "13px", height: "13px" } }),
                                    "Connect"))),
                        React.createElement(teamsnap_ui_1.PanelFooter, { mods: "u-textLeft" },
                            React.createElement("div", null, "To be used to connect a Snapi Division to this Organization. The Division must be a root division."))))))));
};
exports.default = OrganizationConnect;
//# sourceMappingURL=organization-connect.js.map